export class News{
    public Title: string;
    public Descripcion: string;
    public Imagen: string;
    public Link: string;
    public Date: Date;
    public Order;
    public Habilitada: boolean;
    public Category;
}